import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  transitId: string;
  notificationId: string;
}

export const useMarkCustomsNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, notificationId }: HookProps) => {
      const result = await apiClient.transit.markCustomsNotificationAsRead.mutation({ params: { transitId, notificationId } });
      if (result.status !== 200) throw result.body;
      return result.body.message;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transit'] });
      toast.success('Notification marked read.');
    },
    onError: (error) => {
      showErrorToast(error, `Error marking the notification as read!`);
    },
  });
};
